import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { apiFetchProfile, apiLogin } from '@/api/useUserApi'

export const useUserStore = defineStore('user', () => {
  const token = ref('')
  const refreshToken = ref('')
  const account = ref('')
  const nickname = ref('')
  /** 积分余额 */
  const pointsBalance = ref(0)

  const isLoggedIn = computed(() => !!token.value)

  /** 账号密码登录（SM2 加密） */
  async function login(username: string, password: string) {
    const res = await apiLogin(username, password)
    token.value = res.token
    refreshToken.value = res.refreshToken || ''
    account.value = res.account
    nickname.value = res.nickname
    pointsBalance.value = res.points
    return res
  }

  /** 退出登录（服务端无状态，仅清本地） */
  function logout() {
    token.value = ''
    refreshToken.value = ''
    account.value = ''
    nickname.value = ''
    pointsBalance.value = 0
  }

  /** 拉取最新用户信息（兑换/取消后刷新积分余额） */
  async function refreshProfile() {
    if (!token.value)
      return
    try {
      const profile = await apiFetchProfile()
      account.value = profile.account ?? account.value
      nickname.value = profile.nickname ?? nickname.value
      pointsBalance.value = profile.points ?? pointsBalance.value
    }
    catch {
      // 静默失败，不打断主流程
    }
  }

  /** 扣减积分（本地乐观更新，随后可 refreshProfile 校准） */
  function deductPoints(count: number) {
    pointsBalance.value = Math.max(0, pointsBalance.value - count)
  }

  /** 增加积分（本地乐观更新） */
  function addPoints(count: number) {
    pointsBalance.value += count
  }

  return {
    token,
    refreshToken,
    account,
    nickname,
    pointsBalance,
    isLoggedIn,
    login,
    logout,
    refreshProfile,
    deductPoints,
    addPoints,
  }
}, { persist: true })
